import React from 'react';


function AboutPage() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">About AASC</h1>

        {/* SECTION 1: Mission */}
        <section className="mb-12">
          <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">Mission</h2>
          <p className="text-gray-800 leading-relaxed">
            The mission of the AI Accountability Standards Council is to establish clear, conservative, and repeatable methodologies for the operational oversight of autonomous AI agents. We provide the technical definitions necessary to ensure safety, accountability, and transparency in the commercial AI services sector.
          </p>
        </section>

        {/* SECTION 2: What AASC Is/Is Not */}
        <section className="mb-12">
          <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">Organizational Identity</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-bold text-[#102A43] mb-2 border-b border-gray-200 pb-1">What AASC Is</h3>
              <ul className="list-disc pl-5 space-y-2 text-gray-800 text-sm">
                <li>An independent standards authority.</li>
                <li>The publisher of the AASC Standards Framework.</li>
                <li>A neutral custodian of technical definitions.</li>
                <li>A non-profit focused on industry integrity.</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-[#102A43] mb-2 border-b border-gray-200 pb-1">What AASC Is Not</h3>
              <ul className="list-disc pl-5 space-y-2 text-gray-800 text-sm">
                <li>A government regulator or enforcement agency.</li>
                <li>A commercial declaration vendor.</li>
                <li>A provider of legal advice.</li>
                <li>A guarantor of business outcomes.</li>
              </ul>
            </div>
          </div>
        </section>

        {/* SECTION 3: Standards Scope */}
        <section className="mb-12">
          <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">Standards Scope</h2>
          <p className="text-gray-800 leading-relaxed">
            Our standards focus exclusively on the "Operational Layer" of AI—the configuration, human-in-the-loop protocols, and management processes surrounding the deployment of models. We do not define standards for the training of foundation models or the development of chip architecture.
          </p>
        </section>

        {/* SECTION 4: Governance */}
        <section className="mb-12">
          <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">Governance</h2>
          <p className="text-gray-800 leading-relaxed">
            The Council is governed by a transparent framework of policies ensuring rigorous oversight. Standards are developed through a consensus-based process involving industry experts, and all governance documents are publicly available for review.
          </p>
        </section>

        {/* SECTION 5: Independence */}
        <section className="bg-gray-100 p-8 rounded-sm">
          <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">Statement of Independence</h2>
          <p className="text-gray-800 text-sm leading-relaxed">
            The AASC maintains strict independence from AI vendors, platform providers, and agency holding companies. This neutrality is essential to our ability to define standards that prioritize public trust and operational safety over commercial interests.
          </p>
        </section>

      </div>
    </>
  );
}

export default AboutPage;